import Field from './Field';

export default class HeatingOutputField extends Field {
    constructor(index, side, name, step) {
        super(name, step);
        this.index = index;
        this.side = side;
    }

    get warning() {
        return this.step.model.heatExchangerOutput[this.index][`${this.side}Warning`]
    }
}